var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.21,5.94H15a3,3,0,0,0-3,3L12,33.3a3,3,0,0,0,3,3H33.29a3,3,0,0,0,3-3V15.06ZM15,33.3V9H25.69v7.6h7.6V33.3Z",
    transform: "translate(-12.01 -5.94)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.59,20.62H27.33V19.36H21v1.26H19.75a1.27,1.27,0,0,0-1.26,1.26v.63a3.15,3.15,0,0,0,2.77,3.12,3.16,3.16,0,0,0,2.28,1.87v2H21v1.26h6.32V29.46H24.8v-2a3.16,3.16,0,0,0,2.28-1.87,3.15,3.15,0,0,0,2.77-3.12v-.63a1.27,1.27,0,0,0-1.26-1.26m-8.84,1.89v-.63H21V24.3a1.9,1.9,0,0,1-1.26-1.78m8.84,0a1.9,1.9,0,0,1-1.26,1.78V21.88h1.26Z",
    transform: "translate(-12.01 -5.94)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.d5e33032aa1e17d9aac995276cc58ba3.svg";
export { ForwardRef as ReactComponent };